import {
	ArenaGamesGridConfiguration,
	HeaderFilterConfiguration
} from "../configurations/config-data-sections/arenas.configuration";

export interface ILiveTableFeedsService {
	readonly liveArenaTabsConfiguration: LiveTableTabConfiguration[];
	readonly currentArenaTabConfiguration: LiveTableTabConfiguration | null;
	readonly tablesData: LiveTablesArray;
	readonly openTablesIds: string[];
	readonly aiSortingGamesMap: Record<number, number> | undefined;
	setCurrentArenaTab(tabId: string): Promise<void>;
	getTableInfo(tableId: number): ILiveTableInfo;
	getLiveGames(): number[];
	moveGamesThatOpenSoonToTheEnd(gamesIds: number[]): number[];
	updateAiRecommendedLiveGames(): void;
	isNavbarVisible: boolean;
}

export class LiveTableTabConfiguration {
	constructor(public readonly gridConfiguration: ArenaGamesGridConfiguration,
				public readonly headerConfiguration: HeaderFilterConfiguration) {
	}
}


export interface ILiveTableInfo {
	GameId: number;
	Name: string;
	MinBet: number;
	MaxBet: number;
	BetBehind: boolean;
	IsOpen: boolean;
	Seats: number,
	SeatsTaken: number[],
	Players: number;
	Dealer: string;
	RouletteLast5Numbers?: string[];
	OperationHoursType: string; // type of operation hours - full or partially
	OperationHoursStartTime?: string; // if not full time - operation hours start time
	OperationHoursEndTime?: string; // if not full time - operation hours end time
	TableImage: string
}

export type LiveTables = { [key: string]: ILiveTableInfo };
export type LiveTablesArray = { tableId: string, tableInfo: ILiveTableInfo }[];
